export default "__VITE_ASSET__D5IyfG6N__"